import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Container, Stack } from "@mui/material";
// import home_page_Image from "../../Assets/home_page_Image.png";
import blogHomeImage from "../../../../../Assets/blogHomeImage.png"; // Ensure this is the correct path
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";
// import { adminUrl } from "../../constants";

const BlogMainPage = ({ bannerDates, values, onClose, sectionNameForApproveAndReject }) => {

  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getBlogSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETBLOGSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "Blog section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);

  return (
    <Box>
      <Box
        sx={{
          // position: "relative", // Needed for positioning child elements

          background: `linear-gradient(90deg, #000000 0%, #54545400 100%), url(${adminUrl}${values?.image || responseData?.additional_data[0]?.banner})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          overflow: "hidden",
          // padding: "90px 50px",
          p: { xs: "50px 0", md: "90px 50px" },
          // left:"100px"
          // minHeight: "90vh", // Adjust height as needed
        }}
      >
        <Container maxWidth="lg" sx={{ zIndex: 2 }}>
          <Box
            display="flex"
            // alignItems="center"
            justifyContent="start"
            flexWrap="wrap"
          >
            {/* Left Section */}
            <Box
              sx={{
                color: "#fff",
              }}
            >
              <Typography variant="h1" textAlign="start">
                {responseData?.heading || values?.title || "Your Ultimate Resource for"}
              </Typography>
              <Typography
                variant="h2"
                textAlign="start"
                sx={{
                  mb: 2,
                }}
              >
                {responseData?.sub_heading || values?.subtitle || "Gold Purchase"}
              </Typography>
              <Typography
                variant="body1"
                textAlign="start"
                sx={{
                  mb: 5,
                  lineHeight: "1.6",
                  color: "#ffffff",
                  // width:"55%",
                  maxWidth: "500px",

                  letterSpacing: "0px",
                  color: "#b0aaaa",
                  opacity: 1,
                }}
              >
                {responseData?.content || values?.content ||
                  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley"}
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
    </Box >
  );
};

export default BlogMainPage;
